import { useSyncExternalStore } from 'react';
import { useDoorStore } from '../stores/doorStore.js';

function subscribe(notify: () => void): () => void {
  const stopStart = useDoorStore.persist.onHydrate(notify);
  const stopFinish = useDoorStore.persist.onFinishHydration(notify);
  return () => {
    stopStart();
    stopFinish();
  };
}

export function useDoorHydrated(): boolean {
  return useSyncExternalStore(subscribe, useDoorStore.persist.hasHydrated, () => false);
}
